<template>
  <v-dialog v-model="dialog" max-width="400">
    <template v-slot:activator="{ on }">
      <div class="pointer" :class="titleClass" v-on="on">
        {{ name }}
        <v-btn icon x-small>
          <v-icon color="primary" small>mdi-information-outline</v-icon>
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>{{ name }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <a @click="companyDetailsRouter(labeler_ndc, name)"
          >See all meds from {{ name }}</a
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Slugify from "slugify";
// import Name from "../dir/file";

export default {
  name: "MedCompanyDialog",
  props: {
    name: null,
    labeler_ndc: null,
    titleClass: {
      type: String,
      default: "text-h6",
    },
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {
    slugText(name) {
      return Slugify(name.toLowerCase());
    },
    // getCompanyMeds(id, name) {
    //   this.$router.push({ path: "/companies/" + id });
    // },
    companyDetailsRouter(labeler_ndc, name) {
      let url = `/meds/companies/${labeler_ndc}/`;
      url += this.slugText(name);
      this.$router.push({ path: url });
    },
  },
  computed: {},
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
